// extracted by mini-css-extract-plugin
export default {"timerWrapper":"timerV2_timerWrapper__bmVXl","timerCellDivider":"timerV2_timerCellDivider__DWA7A"};